import React from 'react';
import { HelpCircle } from 'lucide-react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../ui/accordion';

const FAQSection = () => {
  const faqItems = [
    {
      question: "Quanto tempo leva para fazer um projeto arquitetônico?",
      answer: "O prazo varia conforme a complexidade do projeto, mas em média leva de 15 a 30 dias úteis. Projetos mais simples podem ficar prontos em menos tempo, enquanto projetos mais complexos podem levar um pouco mais. Fornecemos um cronograma detalhado após a primeira reunião."
    },
    {
      question: "Quais documentos são necessários para regularizar meu imóvel?",
      answer: "Os documentos básicos incluem: escritura ou matrícula do imóvel, certidões negativas, projeto arquitetônico (se houver), fotos do imóvel e documentos pessoais do proprietário. Durante a visita técnica gratuita, faremos uma análise completa e listaremos todos os documentos específicos para o seu caso."
    },
    {
      question: "Quanto custa para tirar o Habite-se?",
      answer: "O valor varia conforme o tamanho e situação do imóvel, além das taxas municipais. Fazemos uma avaliação gratuita e fornecemos um orçamento detalhado sem compromisso. O investimento compensa pela valorização do imóvel e segurança jurídica."
    },
    {
      question: "Vocês atendem em quais cidades?",
      answer: "Atendemos nas cidades de Natal, Parnamirim, Extremoz, Macaíba e São Gonçalo do Amarante, todas no Rio Grande do Norte. Para outras localidades próximas, entre em contato para verificarmos a viabilidade."
    },
    {
      question: "A primeira visita técnica é realmente gratuita?",
      answer: "Sim! A primeira visita técnica é totalmente gratuita e sem compromisso. Durante essa visita, fazemos uma avaliação completa da situação do seu imóvel e apresentamos um orçamento detalhado. Você só fecha o serviço se realmente quiser."
    },
    {
      question: "Preciso estar presente durante a vistoria?",
      answer: "É recomendável que você ou um responsável esteja presente para acompanhar a vistoria, esclarecer dúvidas sobre o imóvel e receber as orientações técnicas. Caso não seja possível, podemos fazer a vistoria com um responsável autorizado."
    },
    {
      question: "Vocês fazem acompanhamento de obra?",
      answer: "Sim! Oferecemos serviço de acompanhamento técnico de obras, incluindo visitas periódicas, verificação de execução conforme projeto, orientação técnica à equipe e relatórios fotográficos. Entre em contato para mais informações sobre esse serviço."
    },
    {
      question: "O projeto 3D está incluso no projeto arquitetônico?",
      answer: "O projeto 3D é um serviço adicional que pode ser contratado junto com o projeto arquitetônico. Ele permite visualizar sua obra antes mesmo de começar a construir, facilitando a tomada de decisões sobre acabamentos, layout e outros detalhes."
    },
    {
      question: "Quanto tempo demora a regularização de um imóvel?",
      answer: "O prazo de regularização varia bastante conforme a situação do imóvel e a prefeitura local, podendo levar de 3 a 12 meses. Trabalhamos para agilizar ao máximo todos os trâmites e mantemos você informado em cada etapa do processo."
    },
    {
      question: "Vocês trabalham com qual forma de pagamento?",
      answer: "Aceitamos diversas formas de pagamento: à vista, parcelado no cartão de crédito, PIX e boleto bancário. As condições são definidas no orçamento e podem ser flexibilizadas conforme o projeto. Entre em contato para conhecer as opções disponíveis."
    }
  ];

  return (
    <section id="faq" className="py-12 sm:py-16 bg-[#F2F2F2]">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10">
            <div className="w-16 h-16 bg-[#073A40] rounded-full flex items-center justify-center mx-auto mb-4">
              <HelpCircle className="text-white" size={32} />
            </div>
            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-[#073A40] mb-4">
              Perguntas Frequentes
            </h2>
            <p className="text-xl sm:text-2xl text-[#06323B] font-medium">
              Tire suas dúvidas sobre nossos serviços
            </p>
          </div>

          <Accordion type="single" collapsible className="space-y-4">
            {faqItems.map((item, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className="bg-white border-2 border-[#A69076]/30 rounded-lg px-6 hover:border-[#A69076] transition-all duration-300 shadow-sm hover:shadow-md"
              >
                <AccordionTrigger className="text-left text-base sm:text-lg font-semibold text-[#073A40] hover:text-[#A69076] hover:no-underline py-4">
                  {item.question}
                </AccordionTrigger>
                <AccordionContent className="text-sm sm:text-base text-[#06323B] leading-relaxed pb-4">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          <div className="text-center mt-10 p-6 bg-white rounded-xl border-2 border-[#A69076]/30">
            <p className="text-lg text-[#073A40] mb-4">
              Não encontrou sua resposta?
            </p>
            <p className="text-base text-[#06323B] mb-4">
              Entre em contato conosco pelo WhatsApp e tire todas as suas dúvidas!
            </p>
            <a
              href="https://wa.me/5584994054759?text=Olá!%20Vim%20pelo%20site%20e%20tenho%20algumas%20dúvidas."
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center px-6 py-3 bg-[#073A40] hover:bg-[#06323B] text-white font-bold rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl"
            >
              Falar no WhatsApp
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
